import styled from "styled-components";

export const StackedButtons = styled.div`
  display: block;
  background-color: var(--ons-color-branded-tint);
`;

export const LeftButtons = styled.div`
  display: flex;
  border-bottom: 2px solid var(--ons-color-ocean-blue);
  padding: 0.6rem 1rem;

  @media (max-width: 739px) {
    display: block;
  }
`;

export const RightButtons = styled.div`
  display: flex;
  padding: 0.6rem 1rem;

  @media (max-width: 739px) {
    display: block;
  }
`;
